import styled from 'styled-components';

const StyledErrorMessage = styled.h2`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ErrorPageNotFound = (): JSX.Element => <StyledErrorMessage>Page not found</StyledErrorMessage>;
